// extracted by mini-css-extract-plugin
export default {"root":"ErrorPageButton__root--20ObC","compact":"ErrorPageButton__compact--NoGUC"};